// extracted by mini-css-extract-plugin
export default {"banner-wrap":"BJOeQ","hidden":"qhZEn","banner--hidden":"hrhQZ","banner":"VyZDs","link":"MZMmY","image":"aP3yp","close-button":"tcU2c"};